var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-header'),_vm._v(" "),_c('main',{staticClass:"px-md-5",staticStyle:{"padding-top":"8rem"},attrs:{"id":"content","role":"main"}},[_c('div',{staticClass:"content container px-5"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }